import wait from "marketingWebsite/utils/wait.js"

export default function useYoutubeVideo () {
    async function handleClickPlayVideo ( videoBlock ) {
        videoBlock.classList.add( "with-video" )

        await wait( 250 )

        const { ytUrl: videoUrl } = videoBlock.dataset

        const iframe = document.createElement( "iframe" )
        iframe.allowfullscreen = true
        iframe.allow = "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        iframe.frameborder = 0
        iframe.src = `${ videoUrl }&autoplay=1&mute=0`

        videoBlock.appendChild( iframe )
        videoBlock.classList.add( "hide-play" )

        return
    }

    function init () {
        const videoBlocks = document.querySelectorAll( ".youtube-video-place" )

        videoBlocks.forEach( ( videoBlock ) => {
            const playButton = videoBlock.querySelector( ".video-play" )

            playButton.addEventListener(
                "click",
                async () => await handleClickPlayVideo( videoBlock ),
                { once: true }
            )
        })
    }

    init()
}
